module.exports = __webpack_public_path__ + "static/media/warning.5fbba116.svg";